import React from "react";
import { AiFillInstagram } from "react-icons/ai";
import { FaFacebook } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";

import { getUrlLanguage } from "../utils/languageFunctions";

const Footer = () => {

    // Assign social media page according the languague of page
    let facebookURL, instagramURL, TiktokURL;

    if(getUrlLanguage() === "/es"){ // Si el lenguaje actual es español, entonces 
        
        facebookURL  = "https://www.facebook.com/profile.php?id=61573039442698";
        instagramURL = "https://www.instagram.com/honkypie_espanol?igsh=MWk5Zm5oanA2ODNheA==";
        TiktokURL    = "https://www.tiktok.com/@honkypie_espanol?_t=ZM-8twR5K9WRNt&_r=1";

    }else{ // Si el lenguaje actual es inglés, entonces
                       
        facebookURL  = "https://www.facebook.com/profile.php?id=61573141527554";
        instagramURL = "https://www.instagram.com/honkypie_?igsh=eWMxMGdtZmpkYjR3";
        TiktokURL    = "https://www.tiktok.com/@honkypie_?_t=ZM-8twQv0kLoBR&_r=1";
    }


    return <section className="bg-gray-200">
        <footer className="container mx-auto grid-cols-10 px-5 py-10 gap-y-2 gap-x-5 pt-10 grid-cols-12 grid-cols-10 gap-x-10">

            <div className="flex justify-between text-gray-500">
                <ul className="flex space-x-4 justify-start">
                    <li>
                        <a href={facebookURL}>
                            <FaFacebook className="w-7 h-auto" />
                        </a>
                    </li>
                    <li>
                        <a href={instagramURL}>
                            <AiFillInstagram className="w-7 h-auto" />
                        </a>
                    </li>
                    <li>
                        <a href={TiktokURL}>
                            <FaTiktok className="w-7 h-auto" />
                        </a>
                    </li>
                </ul>

                <div>
                    <p className="font-bold italic">
                        © 2024 Honky Pie by Pedro Jonz.
                    </p>
                </div>
            </div>
        </footer>
    </section>
}; 

export default Footer; 